import { InformExisting } from '@/pages/inform-existing';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/inform-existing')({
	component: InformExisting,
});
